import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  header: {
    description: 'Header for Tax Id Address information',
    defaultMessage: 'Tax ID Address Information',
    id: 'jXAjVz',
  },
});
